module.exports = __webpack_public_path__ + "static/media/yuanqu_cover.cab0e066.png";